import dayjs from "dayjs";

import { FALLBACK_TIMEZONE } from "src/store/timezoneStore";

// 절대 시각(instant, ISO 8601 with offset) 을 사용자 timezone 으로 변환해 표시한다.
// dayjs 의 format 패턴 문자열을 그대로 받는다 (예: "YYYY/MM/DD HH:mm").
//
// 사전 조건: `_app.tsx` 에서 `dayjs.extend(utc)` + `dayjs.extend(timezone)` 등록 완료.
//
// tz 옵션 미지정 시 `FALLBACK_TIMEZONE` 으로 변환한다 — `timezoneAtom` 의 SSR 폴백과
// 같은 의미(timezone 감지 실패 시 안전판) 이므로 정책이 바뀌어도 두 곳이 함께 바뀐다.
export function formatInstant(
  iso: string,
  pattern: string,
  options?: { tz?: string }
): string {
  if (!iso) return "";
  const tz = options?.tz ?? FALLBACK_TIMEZONE;
  return dayjs(iso).tz(tz).format(pattern);
}
